import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase';
import { parse as parseQueryString } from 'querystringify';

import store from '@/store';
import { SET_TARGET_ROUTE } from '@/store/mutationTypes';

// import SpecialPageContainer from '@/containers/SpecialPageContainer';
import GlobalPageContainer from '@/containers/GlobalPageContainer';
import MainPageContainer from '@/containers/MainPageContainer';

import LoginPage from '@/containers/LoginPage';
import LogoutPage from '@/containers/LogoutPage';
import HomePage from '@/containers/HomePage';
import PostPage from '@/containers/PostPage';
import PostEditPage from '@/containers/PostEditPage';
import PostAddPage from '@/containers/PostAddPage';
import NotFoundPage from '@/containers/NotFoundPage';
// import SettingsPage from '@/containers/SettingsPage';

import InvitesPage from '@/containers/InvitesPage';
import UsersAdminPage from '@/containers/UsersAdminPage';

Vue.use(Router);

function checkAdminAccess(to, from, next) {
  if (store.getters.isAdmin) {
    next();
  } else {
    next({ name: 'notFound' });
  }
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: GlobalPageContainer,
      children: [
        {
          path: '/login',
          name: 'login',
          component: LoginPage,
          meta: {
            allowedForUnloggedUsers: true,
            logoSize: 'giant',
            pageContainerClass: 'login',
            hideToolbar: true,
          },
          beforeEnter(to, from, next) {
            const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
              unsubscribe();
              if (user) {
                next({ name: 'loading' });
              } else {
                next();
              }
            });
          },
        },
        {
          path: '/login/invite/:invite',
          name: 'loginWithInvite',
          component: LoginPage,
          meta: {
            allowedForUnloggedUsers: true,
            logoSize: 'giant',
            pageContainerClass: 'login',
            hideToolbar: true,
          },
        },
        {
          path: '/logout',
          name: 'logout',
          component: LogoutPage,
        },
        {
          path: '',
          component: MainPageContainer,
          children: [
            {
              path: '/',
              name: 'home',
              component: HomePage,
              meta: {
                logoSize: 'big',
              },
            },
            {
              path: '/p/:alias/public/:publicKey',
              name: 'publicPost',
              component: PostPage,
              meta: {
                allowedForUnloggedUsers: true,
              },
            },
            {
              path: '/p/:alias',
              name: 'post',
              component: PostPage,
            },
            // {
            //   path: '/settings',
            //   name: 'settings',
            //   component: SettingsPage,
            // },
            {
              path: '/post/:id/edit',
              name: 'postEdit',
              component: PostEditPage,
              beforeEnter: checkAdminAccess,
            },
            {
              path: '/post/add',
              name: 'postAdd',
              component: PostAddPage,
              beforeEnter: checkAdminAccess,
            },
            {
              path: '/admin/invites',
              name: 'invites',
              component: InvitesPage,
              beforeEnter: checkAdminAccess,
            },
            {
              path: '/admin/users',
              name: 'users',
              component: UsersAdminPage,
              beforeEnter: checkAdminAccess,
            },
          ],
        },
        {
          path: '/404',
          name: 'notFound',
          component: NotFoundPage,
          meta: {
            logoSize: 'giant',
            pageContainerClass: 'not-found',
          },
        },
      ],
    },
    { path: '*', redirect: { name: 'notFound' } },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.allowedForUnloggedUsers) {
    next();
  } else {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      // console.log('beforeEach', user);
      unsubscribe();
      if (user) {
        next();
      } else {
        store.commit(SET_TARGET_ROUTE, to);

        const query = parseQueryString(location.search);
        if (query.invite) {
          next({ name: 'loginWithInvite', params: { invite: query.invite } });
        } else {
          next({ name: 'login' });
        }
      }
    });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js